// Campus photo for /colleges/brown-university: CC BY 4.0, by P. Hughes, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ABrown_University_-_Main_Campus_03.jpg), checked 2026-10-02 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/brown-university/; credited under the photo.
const photo = {
    "slug": "brown-university",
    "alt": "Red brick colonial-era hall with a cupola, trees and lawns on the Brown University campus",
    "src": "/colleges/brown-university/campus-1600.webp",
    "srcSmall": "/colleges/brown-university/campus-800.webp",
    "srcMid": "/colleges/brown-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/brown-university/og.jpg",
    "title": "Brown University - Main Campus 03",
    "author": "P. Hughes",
    "license": "CC BY 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ABrown_University_-_Main_Campus_03.jpg",
    "read": "2026-10-01"
};

export default photo;
